"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
function fromOperationExtraRaw(extra) {
    if (extra && extra.celoOperationValue) {
        return Object.assign(Object.assign({}, extra), { celoOperationValue: new bignumber_js_1.BigNumber(extra.celoOperationValue) });
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    if (extra && extra.celoOperationValue) {
        return Object.assign(Object.assign({}, extra), { celoOperationValue: extra.celoOperationValue.toString() });
    }
    return extra;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports.default = {
    fromOperationExtraRaw,
    toOperationExtraRaw,
};
//# sourceMappingURL=account.js.map